import { compact } from 'lodash';

import {
  abbrToKeyMap,
  DEFAULT_STRAT_KEYS,
  stratificationsConfig,
  StratKey,
} from './startifications.config';

export function abbrToKeys(abbrStr: string) {
  const abbr = abbrStr.split(',');
  const keys = abbr.map((abbr) => {
    const key = abbrToKeyMap[abbr];
    if (!key) {
      return null;
    }
    return key;
  });

  return compact(keys);
}

export function keysToAbbr(keys: readonly StratKey[]) {
  const abbrs = keys.map((key) => {
    const config = stratificationsConfig[key as StratKey];
    return config?.abbr;
  });

  return compact(abbrs).join(',');
}

/**
 * Resolve the `strats` URL param into the selection to render.
 *
 * `null` is an absent param — nobody has touched the selection, so open on the defaults.
 * `''` is a present-but-empty param, which is what deselecting every strat writes, since
 * `keysToAbbr([])` is the empty string. Those two must not be conflated: a truthiness test
 * treats the cleared case as untouched, snaps the defaults back, and makes clearing every
 * strat impossible.
 */
export function resolveSelectedStrats(abbrStr: string | null): StratKey[] {
  if (abbrStr === null) {
    return [...DEFAULT_STRAT_KEYS];
  }
  if (abbrStr === '') {
    return [];
  }

  // A non-empty param that decodes to nothing is a stale bookmark or a
  // hand-edited URL naming abbreviations that no longer exist — not a
  // deliberate clear-all, which only ever writes the empty string.
  const keys = abbrToKeys(abbrStr);
  return keys.length > 0 ? keys : [...DEFAULT_STRAT_KEYS];
}
